import { render, staticRenderFns } from "./AulasFrequencia.vue?vue&type=template&id=c305f3d2&"
import script from "./AulasFrequencia.vue?vue&type=script&lang=js&"
export * from "./AulasFrequencia.vue?vue&type=script&lang=js&"
import style0 from "./AulasFrequencia.vue?vue&type=style&index=0&id=c305f3d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports